/**
 * Ауховые — 2 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const АУХОВЫЕ = [
    // ── Восточная Азия ──
    {
        id: 'mandarin_fish',
        семейство: 'ауховые',
        latin: 'Siniperca chuatsi',
        повадка: 'засадный',
        minKg: 0.15,
        maxKg: 3.5,
        typicalKg: 0.6,
        typicalLengthM: 0.35,
        depthM: 3,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'панцирная',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 12, опт: 25, макс: 32 },
        течение: 'слабое',
        держится: ['коряги', 'трава', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'spinner', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'leopard_mandarin',
        семейство: 'ауховые',
        latin: 'Siniperca scherzeri',
        повадка: 'засадный',
        minKg: 0.1,
        maxKg: 2,
        typicalKg: 0.4,
        typicalLengthM: 0.3,
        depthM: 3,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'панцирная',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 10, опт: 23, макс: 30 },
        течение: 'слабое',
        держится: ['камни', 'коряги', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'wobbler', вес: 0.4 },
            { чем: 'spinner', вес: 0.2 },
        ],
    },
];
//# sourceMappingURL=sinipercids.js.map